module.exports = __webpack_public_path__ + "img/icon-copy.1855eeca.png";